export default class Array {
  public static compareStringList(previous: string[], current: string[]) {
    const newValues = current.filter((value) => !previous.includes(value));
    const removedValues = previous.filter((value) => !current.includes(value));

    if (newValues.length > 0 || removedValues.length > 0) {
      return true;
    }
    return false;
  }
}
